import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import HeroPreview from "@/pages/HeroPreview";
import { installExtensionErrorFilter } from "@/lib/suppressExtensionErrors";

// Must run before React mounts so the capture-phase listeners are in place
// when extension content scripts throw their first errors.
installExtensionErrorFilter();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {window.location.pathname.startsWith("/preview") ? <HeroPreview /> : <App />}
    </QueryClientProvider>
  </React.StrictMode>,
);
